// tslint:disable-next-line:no-submodule-imports
import 'react-app-polyfill/ie9';
// tslint:disable-next-line:no-submodule-imports
import 'react-app-polyfill/stable';

// tslint:disable-next-line:no-submodule-imports
import 'resize-observer-polyfill/dist/ResizeObserver.global';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
